import React from 'react';

export const CardChannelName = ({ channelName }: { channelName: string | undefined }) => {
  return channelName ? <span>{channelName}</span> : null;
};
